module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.save($event)
      }
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block form form-horizontal"
  }, [_c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'has-danger': _vm.$v.model.nome.$error
    }
  }, [_c('label', [_vm._v("Nome*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.nome),
      expression: "model.nome"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.model.nome)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "nome", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'dropdown-has-error': _vm.$v.model.tipo.$error
    }
  }, [_c('label', [_vm._v("Espécie*")]), _vm._v(" "), _c('select2', {
    attrs: {
      "options": _vm.tipos,
      "placeholder": "Selecione a espécie",
      "select-option": true
    },
    model: {
      value: (_vm.model.tipo),
      callback: function($$v) {
        _vm.$set(_vm.model, "tipo", $$v)
      },
      expression: "model.tipo"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'dropdown-has-error': _vm.$v.model.id_raca.$error
    }
  }, [_c('label', [_vm._v("Raça")]), _vm._v(" "), _c('Select', {
    attrs: {
      "options": _vm.racas,
      "opt-text": "nome",
      "placeholder": "Selecionar",
      "select-option": true
    },
    model: {
      value: (_vm.model.id_raca),
      callback: function($$v) {
        _vm.$set(_vm.model, "id_raca", $$v)
      },
      expression: "model.id_raca"
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "selected": ""
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Nascimento*")]), _vm._v(" "), _c('input-datepicker', {
    attrs: {
      "disabled": false,
      "readonly": false,
      "group": false,
      "autoclose": true,
      "required": true
    },
    model: {
      value: (_vm.model.nascimento),
      callback: function($$v) {
        _vm.$set(_vm.model, "nascimento", $$v)
      },
      expression: "model.nascimento"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'dropdown-has-error': _vm.$v.model.tamanho.$error
    }
  }, [_c('label', [_vm._v("Tamanho*")]), _vm._v(" "), _c('Select2', {
    attrs: {
      "options": _vm.tamanhos,
      "opt-id": "id",
      "opt-text": "text"
    },
    model: {
      value: (_vm.model.tamanho),
      callback: function($$v) {
        _vm.$set(_vm.model, "tamanho", $$v)
      },
      expression: "model.tamanho"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-4",
    class: {
      'dropdown-has-error': _vm.$v.model.sexo.$error
    }
  }, [_c('label', [_vm._v("Sexo*")]), _vm._v(" "), _c('Select2', {
    attrs: {
      "options": _vm.sexos,
      "opt-id": "id",
      "opt-text": "text"
    },
    model: {
      value: (_vm.model.sexo),
      callback: function($$v) {
        _vm.$set(_vm.model, "sexo", $$v)
      },
      expression: "model.sexo"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [_c('div', {
    staticClass: "col-md-4",
    class: {
      'has-danger': _vm.$v.model.corPelo.$error
    }
  }, [_c('label', [_vm._v("Cor do Pelo*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.corPelo),
      expression: "model.corPelo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.model.corPelo)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "corPelo", $event.target.value)
      }, function($event) {
        _vm.$v.model.corPelo.$touch()
      }]
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 align-self-center"
  }, [_c('label', [_vm._v("Está com vacinação em dia?*")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input-toggle', {
    attrs: {
      "value": _vm.model.vacinacaoEmDia
    },
    model: {
      value: (_vm.model.vacinacaoEmDia),
      callback: function($$v) {
        _vm.$set(_vm.model, "vacinacaoEmDia", $$v)
      },
      expression: "model.vacinacaoEmDia"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3 align-self-center"
  }, [_c('label', [_vm._v("Doença ou lesão preexistente?*")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input-toggle', {
    attrs: {
      "value": _vm.model.doencaLesao
    },
    model: {
      value: (_vm.model.doencaLesao),
      callback: function($$v) {
        _vm.$set(_vm.model, "doencaLesao", $$v)
      },
      expression: "model.doencaLesao"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group row"
  }, [(_vm.model.doencaLesao) ? _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', [_vm._v("Descrição da doença ou lesão*")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.model.doencaLesaoDescricao),
      expression: "model.doencaLesaoDescricao"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "6",
      "cols": "60",
      "type": "text",
      "maxlength": "1000"
    },
    domProps: {
      "value": (_vm.model.doencaLesaoDescricao)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.model, "doencaLesaoDescricao", $event.target.value)
      }
    }
  })]) : _vm._e()]), _vm._v(" "), _c('file-image', {
    attrs: {
      "arquivo": _vm.model.arquivo
    },
    model: {
      value: (_vm.file),
      callback: function($$v) {
        _vm.file = $$v
      },
      expression: "file"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "card-footer text-right"
  }, [_c('router-link', {
    staticClass: "btn btn-link",
    attrs: {
      "to": {
        name: 'list-pet'
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Salvar")])], 1)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('i', {
    staticClass: "fa fa-menu"
  }), _vm._v(" Pet\n                    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-76c07722","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/pets/Form.vue
// module id = 883
// module chunks = 1